import { Type } from "class-transformer";
import { forwardRef } from '@angular/core';
import { DeliveryDetail } from '../../../../models/delivery-detail.model';
import { Price } from '../../../../models/price.model';
import { Quantity } from '../../../../models/quantity.model';
import { Company } from '../../../../models/company.model';
import { Location } from '../../../../models/location.model';
import { LoadingRate } from '../../../../models/loading_rate.model';
import { Port } from '../../../../models/port.model';
import { Berth } from '../../../../models/berth.model';
import { TRADITIONAL_BUSINESS_TYPE } from './silo-bag.model';
import { PrimitiveUnit } from "../../../../models/unit.model";

export class QuanityCalculator {
  /** Commissions, freight, etc. */
  additionals?: number;
  /** Amount of money to settle. */
  amount?: Price;
  /**
   * Reference price per unit (in general, tons).
   * In the same currency as the amount.
   */
  price?: number;
  warranty?: number;
  vat: number = 0;

  constructor(data: Partial<QuanityCalculator> = {}) {
    this.amount = new Price();

    Object.assign(this, data);
  }
};

/**
 * Datos del formulario de la Bolsa de Comercio de Rosario que no existen en la
 * negociación. Sólo para negocios ODD: api2 los manda a Confirma (códigos BCR).
 */
export class ConfirmaDetail {
  /** Tabla de transportes BCR: A camión/vagón, B barcaza, C camión, V vagón. */
  medio_transporte: 'A' | 'B' | 'C' | 'V' = 'C';
  /** Tabla mercadería propia BCR: '1' sí, '2' no. */
  produccion_vendedor: '1' | '2' = '2';
  /** Aporte voluntario al Fondo Federal Agropecuario. */
  aporte_ffa: boolean = false;
}

export class BusinessDetail {

  @Type(forwardRef(() => Price) as any)
  price: Price;

  @Type(forwardRef(() => Location) as any)
  origin: Location;

  geo_origin: any[];

  harvest: string;
  /** Campaña declarada ante AFIP/ARCA; puede diferir de la entrega real. */
  harvest_afip: string;
  payment_terms: PrimitiveUnit;
  loading_rate: LoadingRate;
  port: Port;
  berth: Berth;
  other_berth: string;
  /** Quién se hace cargo de la logística de entrega. */
  logistic_condition: 'buyer' | 'seller';
  /** Tipo de negocio: ODD (Siloreal) o Tradicional. */
  business_type: 'odd' | 'tradicional';

  /** Datos para el contrato en Confirma (BCR). Sólo ODD. */
  @Type(() => ConfirmaDetail)
  confirma?: ConfirmaDetail;

  /** Tipo de negocio efectivo: una orden sin valor se considera tradicional. */
  get business_type_string(): string {
    return this.business_type || TRADITIONAL_BUSINESS_TYPE;
  }

  @Type(forwardRef(() => DeliveryDetail) as any)
  delivery: DeliveryDetail;

  @Type(forwardRef(() => Quantity) as any)
  quantity: Quantity;

  @Type(() => QuanityCalculator)
  quantity_calculator: QuanityCalculator;

  authorized_buyers: Company[];
  sustainable?: boolean;

  constructor(
  ) {
    this.price = new Price();
    this.origin = null;
    this.harvest = null;
    this.harvest_afip = null;
    this.business_type = null;
    this.quantity = new Quantity();
    this.authorized_buyers = [];
    this.delivery = new DeliveryDetail();
    this.loading_rate = new LoadingRate();
  }
}
